import React, { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { FiHome, FiChevronDown, FiDownload, FiPlus } from "react-icons/fi";
import AddEventModal from "../../modals/calendar/AddEventModal";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb, Col } from "react-bootstrap";

const options = [
  "Today",
  "Yesterday",
  "Last 7 Days",
  "Last 30 Days",
  "This Year",
  "Next Year",
  "Custom Range",
];

export default function CalendarHeader() {
  const [showModal, setShowModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Last 7 Days");
  const [date, setDate] = useState("04/08/2026 - 04/14/2026");

  const handleSelect = (item) => {
    setSelected(item);
    setOpen(false);

    // Dummy date logic (you can replace with real logic)
    switch (item) {
      case "Today":
        setDate("04/14/2026 - 04/14/2026");
        break;
      case "Yesterday":
        setDate("04/13/2026 - 04/13/2026");
        break;
      case "Last 7 Days":
        setDate("04/08/2026 - 04/14/2026");
        break;
      case "Last 30 Days":
        setDate("03/15/2026 - 04/14/2026");
        break;
      default:
        setDate("Custom Range");
    }
  };

  return (
    <div className="page-breadcrumb">
      {/* LEFT */}
      <Col md={4} sm={12}>
        <div className="my-auto mb-2">
          <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Calendar</h4>

          <Breadcrumb
            style={{
              background: "transparent",
              padding: 0,
              margin: 0,
              fontSize: "14px",
            }}
          >
            <Breadcrumb.Item>
              <Link to="/">
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                  }}
                />
              </Link>
            </Breadcrumb.Item>

            <MdKeyboardArrowRight className="mt-1 fs-5" />

            <Breadcrumb.Item
              linkAs="span"
              className="text-dark text-decoration-none fs-6"
            >
              Application
            </Breadcrumb.Item>

            <MdKeyboardArrowRight className="mt-1 fs-5" />

            <Breadcrumb.Item active>
              <span className="text-dark fs-6">Calendar</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </Col>

      {/* RIGHT */}
      <div className="right-actions">
        <div className="date-wrapper">
          {/* INPUT */}
          <div className="input-icon" onClick={() => setOpen(!open)}>
            <input type="text" className="form-control-input" value={date} readOnly />
            <FiChevronDown />
          </div>

          {/* DROPDOWN */}
          {open && (
            <div className="dropdown-box">
              {options.map((item, i) => (
                <div
                  key={i}
                  className={`custom-date-item ${
                    selected === item ? "active" : ""
                  }`}
                  onClick={() => handleSelect(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          )}
        </div>

        <Dropdown>
          <Dropdown.Toggle className="text-dark border border-2 bg-white">
            <FiDownload className="me-1" /> Export
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <Dropdown.Item>Export as PDF</Dropdown.Item>
            <Dropdown.Item>Export as Excel</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Button className="btn-orange" onClick={() => setShowModal(true)}>
          <FiPlus className="me-1" /> Create
        </Button>
      </div>

      {/* ✅ SEPARATE MODAL */}
      <AddEventModal show={showModal} handleClose={() => setShowModal(false)} />
      <style>
        {`
          /* HEADER */
          .page-breadcrumb {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            padding: 15px 0;
          }

          .page-title {
            font-size: 22px;
            font-weight: 600;
          }

          .breadcrumb {
            display: flex;
            align-items: center;
            color: #6b7280;
            font-size: 14px;
          }

          .breadcrumb .active {
            color: #111827;
            font-weight: 500;
          }

          /* RIGHT ACTIONS */
          .right-actions {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
          }

          .date-wrapper {
            position: relative;
            min-width: 240px;
          }

          .input-icon {
            position: relative;
            cursor: pointer;
          }

          .input-icon input {
            width: 100%;
            padding-right: 42px;
            height: 40px;
            border: 1px solid #d7dfea;
            border-radius: 8px;
            background: #fff;
            color: #111827;
            font-size: 0.95rem;
            font-weight: 500;
          }

          .input-icon input:focus {
            outline: none;
            box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
            border-color: #ff6a00;
          }

          .input-icon svg {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            color: #6b7280;
            pointer-events: none;
          }

          .dropdown-box {
            position: absolute;
            z-index: 99;
            top: calc(100% + 10px);
            left: 0;
            width: 100%;
            background: #fff;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
            overflow: hidden;
          }

          .custom-date-item {
            padding: 12px 16px;
            cursor: pointer;
            color: #374151;
            font-size: 0.95rem;
            transition: background 0.15s ease, color 0.15s ease;
          }

          .custom-date-item:hover {
            background: #f8fafc;
            color: #111827;
          }

          .custom-date-item.active {
            background: #ff6a00;
            color: #fff;
          }

          .custom-date-item + .custom-date-item {
            border-top: 1px solid #f1f5f9;
          }

          .btn-orange {
            background: #ff6a00;
            border: none;
            color: #fff;
          }

          .btn-orange:hover {
            background: #e65c00;
          }

          .btn-white {
            background: #fff;
            border: 1px solid #ddd;
          }

          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .close-btn {
            border: none;
            background: transparent;
            font-size: 18px;
          }

          @media (max-width: 768px) {
            .page-breadcrumb {
              flex-direction: column;
              align-items: flex-start;
              gap: 10px;
            }

            .right-actions {
              width: 100%;
              flex-wrap: wrap;
            }

            .date-wrapper {
              width: 100%;
              min-width: unset;
            }
          }

            .form-control-input {
  display: block;
  width: 100%;
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #2a2f3a;
  appearance: none;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
}
        `}
      </style>
    </div>
  );
}
